<template>
  <div class="space-y-4">
    <div class="text-center mb-6">
      <h3 class="text-2xl font-bold text-gray-900 mb-2">选择测试类型</h3>
    
    </div>

    <div class="grid md:grid-cols-2 gap-4">
      <!-- 给自己测(新版) -->
      <div
        @click="selectTestType('self')"
        :class="[
          'cursor-pointer rounded-xl border-2 p-6 transition-all hover:shadow-lg',
          selectedType === 'self'
            ? 'border-psychology-primary bg-psychology-primary-5 shadow-md'
            : 'border-gray-200 hover:border-psychology-primary-20'
        ]"
      >
        <div class="flex items-start justify-between mb-3">
          <div class="flex items-center gap-3">
            <div class="text-3xl">💝</div>
            <div>
              <h4 class="font-semibold text-lg text-gray-900">给自己测(新版)</h4>
              <span class="inline-block px-2 py-0.5 bg-psychology-primary text-white text-xs rounded-full mt-1">
                推荐
              </span>
            </div>
          </div>
          <div v-if="selectedType === 'self'" class="text-psychology-primary">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
              <path d="m9 11 3 3L22 4"></path>
            </svg>
          </div>
        </div>
        <p class="text-sm text-gray-600 mb-3">
          通过深度心理学问题,探索你在恋爱关系中的真实倾向
        </p>
        <div class="flex items-center gap-4 text-xs text-gray-500">
          <span>📝 40题</span>
          <span>⏱️ 8-12分钟</span>
          <span>🎯 4维度</span>
        </div>
      </div>

      <!-- 为恋人测(新版) -->
      <div
        @click="selectTestType('partner')"
        :class="[
          'cursor-pointer rounded-xl border-2 p-6 transition-all hover:shadow-lg',
          selectedType === 'partner'
            ? 'border-psychology-primary bg-psychology-primary-5 shadow-md'
            : 'border-gray-200 hover:border-psychology-primary-20'
        ]"
      >
        <div class="flex items-start justify-between mb-3">
          <div class="flex items-center gap-3">
            <div class="text-3xl">💑</div>
            <div>
              <h4 class="font-semibold text-lg text-gray-900">为恋人测(新版)</h4>
              <span class="inline-block px-2 py-0.5 bg-psychology-primary text-white text-xs rounded-full mt-1">
                推荐
              </span>
            </div>
          </div>
          <div v-if="selectedType === 'partner'" class="text-psychology-primary">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
              <path d="m9 11 3 3L22 4"></path>
            </svg>
          </div>
        </div>
        <p class="text-sm text-gray-600 mb-3">
          从第三人称视角,评估恋人的年上年下倾向
        </p>
        <div class="flex items-center gap-4 text-xs text-gray-500">
          <span>📝 40题</span>
          <span>⏱️ 8-12分钟</span>
          <span>🎯 4维度</span>
        </div>
      </div>

      <!-- 给自己测(原版) -->
      <div
        @click="selectTestType('self_new')"
        :class="[
          'cursor-pointer rounded-xl border-2 p-6 transition-all hover:shadow-lg',
          selectedType === 'self_new'
            ? 'border-psychology-secondary bg-psychology-secondary-5 shadow-md'
            : 'border-gray-200 hover:border-psychology-secondary-20'
        ]"
      >
        <div class="flex items-start justify-between mb-3">
          <div class="flex items-center gap-3">
            <div class="text-3xl">💖</div>
            <div>
              <h4 class="font-semibold text-lg text-gray-900">给自己测(原版)</h4>
              <span class="inline-block px-2 py-0.5 bg-psychology-secondary text-white text-xs rounded-full mt-1">
                经典
              </span>
            </div>
          </div>
          <div v-if="selectedType === 'self_new'" class="text-psychology-secondary">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
              <path d="m9 11 3 3L22 4"></path>
            </svg>
          </div>
        </div>
        <p class="text-sm text-gray-600 mb-3">
          经典版本,更直接的问题设计
        </p>
        <div class="flex items-center gap-4 text-xs text-gray-500">
          <span>📝 40题</span>
          <span>⏱️ 8-12分钟</span>
          <span>🎯 4维度</span>
        </div>
      </div>

      <!-- 为恋人测(原版) -->
      <div
        @click="selectTestType('partner_new')"
        :class="[
          'cursor-pointer rounded-xl border-2 p-6 transition-all hover:shadow-lg',
          selectedType === 'partner_new'
            ? 'border-psychology-secondary bg-psychology-secondary-5 shadow-md'
            : 'border-gray-200 hover:border-psychology-secondary-20'
        ]"
      >
        <div class="flex items-start justify-between mb-3">
          <div class="flex items-center gap-3">
            <div class="text-3xl">💏</div>
            <div>
              <h4 class="font-semibold text-lg text-gray-900">为恋人测(原版)</h4>
              <span class="inline-block px-2 py-0.5 bg-psychology-secondary text-white text-xs rounded-full mt-1">
                经典
              </span>
            </div>
          </div>
          <div v-if="selectedType === 'partner_new'" class="text-psychology-secondary">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
              <path d="m9 11 3 3L22 4"></path>
            </svg>
          </div>
        </div>
        <p class="text-sm text-gray-600 mb-3">
          经典版本,评估恋人的恋爱倾向
        </p>
        <div class="flex items-center gap-4 text-xs text-gray-500">
          <span>📝 40题</span>
          <span>⏱️ 8-12分钟</span>
          <span>🎯 4维度</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TestTypeSelector',
  props: {
    modelValue: {
      type: String,
      default: ''
    }
  },
  emits: ['update:modelValue'],
  data() {
    return {
      selectedType: this.modelValue || ''
    }
  },
  watch: {
    modelValue(newVal) {
      this.selectedType = newVal
    }
  },
  methods: {
    selectTestType(type) {
      this.selectedType = type
      this.$emit('update:modelValue', type)
    }
  }
}
</script>

